import { useCallback } from 'react';

import * as evmChains from 'viem/chains';

import { Currency, CAIP_122_IDS, SOLANA_CHAIN_ID } from '@/constants';

const CHAIN_ID_TO_LABEL: Record<string, string> = {
  // EVM
  [evmChains.mainnet.id]: 'Ethereum',
  [evmChains.bsc.id]: 'BNB Chain',
  [evmChains.polygon.id]: 'Polygon',
  [evmChains.arbitrum.id]: 'Arbitrum',
  [evmChains.base.id]: 'Base',
  [evmChains.tron.id]: 'Tron',

  // Bitcoin-like
  [BigInt('0x' + CAIP_122_IDS[Currency.BTC].split(':')[1]).toString()]: 'Bitcoin',
  [BigInt('0x' + CAIP_122_IDS[Currency.DOGE].split(':')[1]).toString()]: 'Dogecoin',
  [BigInt('0x' + CAIP_122_IDS[Currency.LTC].split(':')[1]).toString()]: 'Litecoin',

  // Solana
  [SOLANA_CHAIN_ID]: 'Solana',

  // Other
  multiversx: 'MultiversX',
};

type ChainIdLike = string | number | bigint;

export const useChainIdToLabel = () => {
  return useCallback((chainId: ChainIdLike): string => {
    const chainIdStr = String(chainId);
    return CHAIN_ID_TO_LABEL[chainIdStr] || `Chain ${chainIdStr}`;
  }, []);
};
